import { allDeviceUserArgent } from '../includes/auth/checkDevice';

// Dedicated feature configuration for the Footer "Mobile App" button.
// Nothing here is wired to a real store yet — flipping these values
// (via the REACT_APP_MOBILE_APP_* env vars, no code change) is the only
// thing needed later to turn on real Store redirection. No URL is ever
// hardcoded in the component itself.
const env = (name, fallback = '') => {
  const value = process.env[name];
  return value === undefined || value === null || value === 'undefined' ? fallback : value;
};

const envBool = (name, fallback) => {
  const value = process.env[name];
  if (value === undefined || value === null || value === 'undefined') return fallback;
  return value === 'true';
};

export const MOBILE_APP_SETTINGS = Object.freeze({
  // Master switch. While false, the button always opens the
  // "Coming Soon" modal, regardless of every other setting below.
  enabled: envBool('REACT_APP_MOBILE_APP_ENABLED', false),
  // While true (the default), the button always opens the "Coming Soon"
  // modal even if `enabled` is turned on — lets ops enable the feature
  // ahead of the actual store submissions without redirecting anyone yet.
  comingSoon: envBool('REACT_APP_MOBILE_APP_COMING_SOON', true),
  // When enabled+comingSoon are both flipped, decides whether the click
  // is routed by device (iOS/Android) automatically.
  autoDetectPlatform: envBool('REACT_APP_MOBILE_APP_AUTO_DETECT', true),
  androidUrl: env('REACT_APP_MOBILE_APP_ANDROID_URL', ''),
  iosUrl: env('REACT_APP_MOBILE_APP_IOS_URL', ''),
  // Optional: a page listing both platforms for desktop visitors. Until
  // this is set, desktop visitors keep seeing the "Coming Soon" modal
  // even after the feature is otherwise enabled.
  desktopUrl: env('REACT_APP_MOBILE_APP_DESKTOP_URL', ''),
});

// Pure resolver — no DOM access besides the existing allDeviceUserArgent()
// device sniffer, so it's easy to unit test with an injected device string.
export const resolveMobileAppAction = (settings = MOBILE_APP_SETTINGS, deviceOverride = null) => {
  if (!settings.enabled || settings.comingSoon) {
    return { type: 'comingSoon' };
  }

  if (settings.autoDetectPlatform) {
    const device = deviceOverride || allDeviceUserArgent().device;
    if (/iPhone|iPad/i.test(device) && settings.iosUrl) {
      return { type: 'redirect', url: settings.iosUrl };
    }
    if (/Android/i.test(device) && settings.androidUrl) {
      return { type: 'redirect', url: settings.androidUrl };
    }
    if (settings.desktopUrl) {
      return { type: 'redirect', url: settings.desktopUrl };
    }
  }

  return { type: 'comingSoon' };
};
